import { render } from "./NavTop.vue?vue&type=template&id=504d4299&scoped=true"
import script from "./NavTop.vue?vue&type=script&lang=js"
export * from "./NavTop.vue?vue&type=script&lang=js"

import "./NavTop.vue?vue&type=style&index=0&id=504d4299&scoped=true&lang=css"

import exportComponent from "/home/regie/projects-2.0/cia-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504d4299"]])

export default __exports__